import { createReducer, on } from '@ngrx/store';

import { SetCheckAllTermsAndConditions, SetDscAcceptanceRequired } from './terms-conditions.actions';
import { termsConditionsInitialState, TermsConditionsState } from './terms-conditions.state';

const termsConditionsDefinition = createReducer(
    termsConditionsInitialState,

    on(SetDscAcceptanceRequired, (state: TermsConditionsState, { acceptanceRequired }): any => {
        return {
            ...state,
            districtSaleContractAcceptanceRequired: acceptanceRequired,
        };
    }),

    on(SetCheckAllTermsAndConditions, (state: TermsConditionsState, { checkAllTermsAndConditions }): any => {
        return {
            ...state,
            checkAllTermsAndConditions,
        };
    })

);

export function termsConditionsReducer(state: TermsConditionsState, action: Action): TermsConditionsState {
    return termsConditionsDefinition(state, action);
}
